import { jsx as L } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ L(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32941 2.07593C7.8504 1.63958 7.11737 1.6416 6.64078 2.08057L4.41298 4.1325L2.15817 6.18672C1.89818 6.42359 1.75 6.75903 1.75 7.11075V12C1.75 12.6904 2.30964 13.25 3 13.25H10.75V16.8909C10.75 17.2409 10.8967 17.5749 11.1545 17.8116L13.3916 19.8659L13.3916 19.8659L13.397 19.8708L15.6611 21.9256C16.1397 22.3601 16.8707 22.3579 17.3467 21.9206L19.5812 19.8681L21.8404 17.8163C22.1013 17.5793 22.25 17.2433 22.25 16.8909V12C22.25 11.3096 21.6904 10.75 21 10.75H13.25V7.11075C13.25 6.75903 13.1018 6.42359 12.8418 6.18672L10.5845 4.13022L10.5845 4.13018L8.32941 2.07593ZM6.10416 5.97368L7.49228 4.69513L8.90086 5.97828L8.90091 5.97832L10.75 7.66292V10.75H4.25V7.66292L6.09914 5.97828L6.09915 5.97829L6.10416 5.97368ZM13.25 16.3417V13.25H19.75V16.3376L17.8978 18.0199L17.8978 18.0199L17.8926 18.0246L16.4961 19.3074L15.0799 18.022L13.25 16.3417Z",
    fill: "currentColor"
  }
);
export {
  e as default
};
